<template>
  <div>
    <v-row class="align-center">
      <v-col cols="8" sm="6" class="text-body-1 text-sm-h6 title pl-6">
        <slot></slot>
      </v-col>
      <v-col cols="4" sm="6">
        <slot name="rightSide"></slot>
      </v-col>
    </v-row>
    <div v-if="separator" class="separator my-3"></div>
  </div>
</template>

<script>
export default {
  name: "sea-header",
  props: {
    separator: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped lang="scss"> @import'../assets/css/variables.scss';
.separator {
  width: 100%;
  height: 30px;
  background-color: $systemcolor;
}
</style>
